import Vue from 'vue'
// import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'

/*
import store from './store'

window.__ = (key, args={}) => {
    let value = _.get(store.getters['translations/data'], key, key);

    // replace with args
    _.eachRight(args, (paramVal, paramKey) => { value = _.replace(value, `:${paramKey}`, paramVal); });

    return (value==key ? '' : value);
};*/

Vue.mixin({
    created() {

    },
    beforeMount() {
        /*this.__translationKeysNotFound = [];
        if(!this.translationKeysIsFetched(_.get(this, 'translation_keys', []))) {
            this.doTranslationsKeyAdd(this.translation_keys);
        }*/
    },
    mounted() {
        /*if(!this.__translationKeysIsFetched) {
            console.log('beforeMount[' + this._uid + ']: call');
            this.doTranslationsKeysGet().then(() => {
                this.$forceUpdate();

                console.log('beforeMount[' + this._uid + ']: call then');
            });
        }*/
    },
    computed : {
        ...mapGetters({
            translationsData : 'translations/data',
            // translationKeysIsFetched: 'translations/keysIsFetched',
        }),
    },
    methods: {
        /*...mapActions({
            'doTranslationsKeyAdd': 'translations/keyAdd',
            'doTranslationsKeysGet': 'translations/keysGet',
        }),*/
        __(key, args={}) {
            // console.log('__['+this._uid+']: ' + key);

            // merge default args
            args = _.merge({
                app_name : this.$store.getters.global.name,
            }, args);

            let value = _.get(this.translationsData, key, key);

            if(value == key) {
                if(!_.isEmpty(this.translation_keys) && !Array.isArray(this.translation_keys)) { this.translation_keys = [this.translation_keys]; }

                _.each(this.translation_keys, (key_collection) => {
                    value = _.get(this.translationsData, key, _.get(this.translationsData, key_collection + '.' + key, key));
                    if(value != key) { return false; }
                });
            }

            // replace with args
            _.eachRight(args, (paramVal, paramKey) => { value = _.replace(value, `:${paramKey}`, paramVal); });

            return (value==key ? '' : value);
        },
    },
});